<template>
	<div>
		<LanguageDropdown
			v-if="loaded"
			:selectedLang="selectedLang"
			@languageIsSelected="languageIsSelected"
			:containerClasses="containerClasses"
		/>
	</div>
</template>
<script>
import LanguageDropdown from "./LanguageDropdown.vue";
import {LANGUAGE, PAGE_NAME} from "@/common/utils/constants.js";
import {EventBusNavbar, EventProjectLanguage} from "@/common/configurations/event-bus.js";

export default {
	name: "ApplicationLanguageControl",
	components: {
		LanguageDropdown
	},
	props: {
		containerClasses: {
			required: false,
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			selectedLang: {},
			loaded: false
		}
	},
	methods: {
		languageIsSelected(language) {
			this.selectedLang = language;
			this.$i18n.locale = language.short;
			localStorage.setItem("language", language.short.toLowerCase());
			let allowedForViewPaths = [PAGE_NAME.singleCS, PAGE_NAME.singleCSWithDates];
			if (allowedForViewPaths.includes(this.$route.name)) {
				EventProjectLanguage.$emit("project-change-language", this.selectedLang.short);
			} else {
				EventBusNavbar.$emit("language-change", this.selectedLang.short);
			}
		}
	},
	mounted() {
		let lang = localStorage.getItem("language");
		if (!lang) {
			lang = LANGUAGE.en.short.toLowerCase();
		}
		this.selectedLang = LANGUAGE[lang];
		this.languageIsSelected(this.selectedLang);
		this.loaded = true;
	},
	created() {
		EventBusNavbar.$on('language-change-from-form', () => {
			this.selectedLang = LANGUAGE[this.$i18n.locale.toLowerCase()];
		});
	},
	destroyed() {
		EventBusNavbar.$off("language-change-from-form");
	}
}
</script>
